import { isNil } from 'lodash';
import { isNetworkAccountType } from 'modules/account-management';
import { AllCampaignsObject } from 'modules/campaigns/config';
import { FEATURE_FLAGS } from 'modules/taboola-common-frontend-modules/account-configurations';

export const onlySelectedCampaignColumn = ({ selectedCampaign }) =>
    !isNil(selectedCampaign?.id) && selectedCampaign?.id !== AllCampaignsObject.id;

export const onlyNetworkColumn = ({ selectedAccount }) => isNetworkAccountType(selectedAccount?.type);

export const isPerformanceRulesActiveOnAccountLevel = selectedAccountConfig =>
    selectedAccountConfig?.[FEATURE_FLAGS.PERFORMANCE_RULES_REPORTS_ENABLED] === 'true';

export const isCreativeLibraryEnabled = selectedAccountConfig =>
    selectedAccountConfig?.[FEATURE_FLAGS.CREATIVE_LIBRARY_ENABLED] === 'true';
